import { useParams } from '@tanstack/react-router';

/** `$projectId` of the current `/projects/$projectId/*` route (`''` outside it). */
export function useProjectId(): string {
  const { projectId } = useParams({ strict: false });
  return projectId ?? '';
}
